module.exports = __webpack_public_path__ + "img/jifen.cd590c7b.webp";